export default __webpack_public_path__ + "static/media/ic-caretDown.de3dd7b3.svg";